module.exports = __webpack_public_path__ + "img/rg_rojo-03.2de6122b.png";